angular.module('app.controllers').controller('DocsCtrl', ['$scope', '$rootScope', 'UI', 'APIRead', 'APIReadTable', 'Table', 'APIData'].append(function(self, root, UI, APIRead, APIReadTable, Table, APIData) {
  self.documents = {
    "es": [
      {
        "id": 10,
        "exhibitor_id": null,
        "video": {
          "title": "Videos - Bloque 1",
          "file": "assets/video/Videos Bloque 1.zip"
        },
        "download_file": {
          "file": "assets/pdf/SSDs 2026 - Bloque 1 -  Automatiza.pdf",
          "thumbs": {
            "300": "assets/pdf/SSDs 2026 - Bloque 1.jpg"
          }
        },
        "title": "SSDs 2026 - Bloque 1",
        "subtitle": "Automatiza la Automatización",
        "sortIndex": 1
      },
      {
        "id": 11,
        "exhibitor_id": null,
        "video": {
          "title": "Videos - Bloque 2",
          "file": "assets/video/Videos Bloque 2.zip"
        },
        "download_file": {
          "file": "assets/pdf/SSDs 2026 - Bloque 2 - Moderniza tu planta incrementando la fiabilidad y productividad.pdf",
          "thumbs": {
            "300": "assets/pdf/SSDs 2026 - Bloque 2.jpg"
          }
        },
        "title": "SSDs 2026 - Bloque 2",
        "subtitle": "Moderniza tu planta incrementando la fiabilidad y productividad",
        "sortIndex": 2
      },
      {
        "id": 12,
        "exhibitor_id": null,
        "video": {
          "title": "Videos - Bloque 3",
          "file": "assets/video/Videos Bloque 3.zip"
        },
        "download_file": {
          "file": "assets/pdf/SSDs 2026 - Bloque3 - Protege y explota los datos que impulsan tu industria.pdf",
          "thumbs": {
            "300": "assets/pdf/SSDs 2026 - Bloque 3.jpg"
          }
        },
        "title": "SSDs 2026 - Bloque 3",
        "subtitle": "Protege y explota los datos que impulsan tu industria",
        "sortIndex": 3
      }
    ],
    "en": [
      {
        "id": 10,
        "exhibitor_id": null,
        "video": {
          "title": "Videos - Session 1",
          "file": "assets/video/Videos Bloque 1.zip"
        },
        "download_file": {
          "file": "assets/pdf/SSDs 2026 - Bloque 1 -  Automatiza.pdf",
          "thumbs": {
            "300": "assets/pdf/SSDs 2026 - Bloque 1.jpg"
          }
        },
        "title": "SSDs 2026 - Session 1",
        "subtitle": "Automate",
        "sortIndex": 1
      },
      {
        "id": 11,
        "exhibitor_id": null,
        "video": {
          "title": "Videos - Session 2",
          "file": "assets/video/Videos Bloque 2.zip"
        },
        "download_file": {
          "file": "assets/pdf/SSDs 2026 - Bloque 2 - Moderniza tu planta incrementando la fiabilidad y productividad.pdf",
          "thumbs": {
            "300": "assets/pdf/SSDs 2026 - Bloque 2.jpg"
          }
        },
        "title": "SSDs 2026 - Session 2",
        "subtitle": "Modernize your plant by increasing reliability and productivity",
        "sortIndex": 2
      },
      {
        "id": 12,
        "exhibitor_id": null,
        "video": {
          "title": "Videos - Session 3",
          "file": "assets/video/Videos Bloque 3.zip"
        },
        "download_file": {
          "file": "assets/pdf/SSDs 2026 - Bloque3 - Protege y explota los datos que impulsan tu industria.pdf",
          "thumbs": {
            "300": "assets/pdf/SSDs 2026 - Bloque 3.jpg"
          }
        },
        "title": "SSDs 2026 - Session 3",
        "subtitle": "Protect and leverage the data that powers your industry",
        "sortIndex": 3
      }
    ]
  };
  return self.downloads = {
    "es": [
      {
        "id": 2,
        "exhibitor_id": null,
        "download_file": {
          "file": "assets/pdf/260301-SIMATIC-SINAMICS-Ofertas-En-vigor-hasta-300926-1.pdf",
          "thumbs": {
            "300": "assets/pdf/260301-SIMATIC-SINAMICS-Ofertas-En-vigor-hasta-300926-1.jpg"
          }
        },
        "title": "Oferta especial SIMATIC & SINAMICS",
        "subtitle": "",
        "sortIndex": 2
      },
      {
        "id": 1,
        "exhibitor_id": null,
        "download_file": {
          "file": "assets/pdf/260301-SIMATIC-IPC-MD-57A-Ofertas-En-vigor-hasta-300626-.pdf",
          "thumbs": {
            "300": "assets/pdf/260301-SIMATIC-IPC-MD-57A-Ofertas-En-vigor-hasta-300626-.jpg"
          }
        },
        "title": "SIMATIC IPC MD-57A",
        "subtitle": "Robusto y listo para trabajar",
        "sortIndex": 1
      }
    ],
    "en": [
      {
        "id": 2,
        "exhibitor_id": null,
        "download_file": {
          "file": "assets/pdf/260301-SIMATIC-SINAMICS-Ofertas-En-vigor-hasta-300926-1.pdf",
          "thumbs": {
            "300": "assets/pdf/260301-SIMATIC-SINAMICS-Ofertas-En-vigor-hasta-300926-1.jpg"
          }
        },
        "title": "Oferta especial SIMATIC & SINAMICS",
        "subtitle": "",
        "sortIndex": 2
      },
      {
        "id": 1,
        "exhibitor_id": null,
        "download_file": {
          "file": "assets/pdf/260301-SIMATIC-IPC-MD-57A-Ofertas-En-vigor-hasta-300626-.pdf",
          "thumbs": {
            "300": "assets/pdf/260301-SIMATIC-IPC-MD-57A-Ofertas-En-vigor-hasta-300626-.jpg"
          }
        },
        "title": "SIMATIC IPC MD-57A",
        "subtitle": "Robusto y listo para trabajar",
        "sortIndex": 1
      }
    ]
  };
}));
